import React from 'react';
import { Search, ShoppingCart, Menu } from 'lucide-react';
export function Header() {
  return <header className="pt-4 md:pt-6 pb-2 border-b-2 border-black" data-id="element-63" data-mp="2dlur6q5gxltb">
      {/* Mobile Layout */}
      <div className="md:hidden" data-id="element-64" data-mp="2ikxy6g50e23x">
        {/* Top Row: Hamburger + Search | Logo */}
        <div className="flex items-center justify-between mb-4" data-id="element-65" data-mp="2nkaiou8eqx3c">
          <div className="flex items-center gap-4" data-id="element-66" data-mp="2nlvesoadeo3b">
            <button className="text-black" data-id="element-67" data-mp="2rmxet7c4346c">
              <Menu className="w-7 h-7" strokeWidth={2.5} data-id="element-68" data-mp="2rlvsu7tk4x9u" />
            </button>
            <button className="text-black" data-id="element-69" data-mp="2wjxijblhnuua">
              <Search className="w-6 h-6" strokeWidth={2.5} data-id="element-70" data-mp="31bys2pr9v7gm" />
            </button>
          </div>
          <a href="/" className="inline-block" data-id="element-71" data-mp="36b1zgguq5prr">
            <h1 className="font-oswald text-3xl font-bold tracking-tighter text-black leading-none" data-id="element-72" data-mp="369ql5n3nkzme">
              MEAT+POULTRY
            </h1>
          </a>
        </div>
        {/* Subscribe Button */}
        <div className="flex justify-center pb-2" data-id="element-73" data-mp="3fcjedvweblev">
          <button className="bg-[#38bdf8] text-white px-8 py-2.5 rounded font-semibold text-base" data-id="element-74" data-mp="2wkkwt7hste14">
            Subscribe for Free
          </button>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden md:flex flex-col md:flex-row justify-between items-end gap-4" data-id="element-75" data-mp="2mmeuios2y5vq">
        {/* Logo */}
        <a href="/" className="inline-block" data-id="element-76" data-mp="2ho3pqsgn6lkd">
          <h1 className="font-oswald text-5xl md:text-6xl font-bold tracking-tighter text-black leading-none" data-id="element-77" data-mp="2hpeogdv8d34m">
            MEAT+POULTRY
          </h1>
        </a>

        {/* Right Actions */}
        <div className="flex items-center gap-5 text-sm font-medium" data-id="element-78" data-mp="3ad144khqfy7u">
          <a href="#" className="hover:underline text-gray-800" data-id="element-79" data-mp="35khf8rdlhgnq">
            SIGN IN
          </a>
          <a href="#" className="hover:underline text-gray-800" data-id="element-80" data-mp="30lelw46z8yvl">
            CREATE ACCOUNT
          </a>

          <div className="flex items-center border-b-2 border-black pb-1 ml-2" data-id="element-81" data-mp="1x7o06rbcorb">
            <input type="text" placeholder="Search" className="outline-none w-32 md:w-48 text-sm placeholder-gray-500" data-id="element-82" data-mp="3tav8gl7x1ljw" />
            <button className="text-black hover:text-gray-600" data-id="element-83" data-mp="1wco59rjub62q">
              <Search className="w-4 h-4 font-bold" strokeWidth={3} data-id="element-84" data-mp="1wbuwym58g8ih" />
            </button>
          </div>

          <button className="text-black hover:text-gray-600" data-id="element-85" data-mp="1hlnq73ol8dxm">
            <ShoppingCart className="w-5 h-5" data-id="element-86" data-mp="1mltbm249l479" />
          </button>

          <button className="bg-[#38bdf8] text-white px-5 py-2 rounded font-semibold hover:bg-sky-500 transition-colors" data-id="element-87" data-mp="18nboa5i9ttpv">
            Subscribe for Free
          </button>
        </div>
      </div>
    </header>;
}